import { noop } from 'lodash';
import { RevisionActionProps } from 'components/tables/data/revision/types';
import { useApi } from 'api/api-context';
import { showNotification } from '@mantine/notifications';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';
import panic from 'errors/panic';

/**
 * Implements the approve action for revision.
 */
export default function useApproveAction() {
  const { getAction } = useApi();

  /**
   * Makes a call to the API to approve the revision.
   */
  async function approveRevision({
    revision: { revisionId, revisionName, kind },
    onStatusChange = noop,
  }: RevisionActionProps) {
    const revisionApproveAction = getAction('RevisionApprove');

    try {
      const { status } = await revisionApproveAction({
        parameters: { revisionId: String(revisionId) },
      });

      onStatusChange({ revisionId, status });

      showNotification({
        title: kind === 'revision' ? 'Revízna správa bola schválená' : 'Formulár bol schválený',
        message:
          kind === 'revision'
            ? `Revíznu správu ${revisionName} ste úspešne schválili.`
            : `Formulár ${revisionName} ste úspešne schválili.`,
        color: SUCCESS_NOTIFICATION_COLOR,
      });
    } catch (error: any) {
      panic(error);
    }
  }

  return { approveRevision };
}
